// Apply the active org's accent color as CSS variables on <html>.
// Everything in the app reads from `--org-accent` / `--org-accent-hover` /
// `--org-accent-fg`, so flipping orgs re-themes the UI instantly.

const DEFAULT_ACCENT = "#d8b854";

function hexToRgb(hex) {
  if (!hex || typeof hex !== "string") return null;
  let h = hex.trim().replace(/^#/, "");
  if (h.length === 3) h = h.split("").map(c => c + c).join("");
  if (h.length !== 6) return null;
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return null;
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

function rgbToHex({ r, g, b }) {
  const c = (v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0");
  return `#${c(r)}${c(g)}${c(b)}`;
}

function lightenHex(hex, amount = 0.12) {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex;
  return rgbToHex({
    r: rgb.r + (255 - rgb.r) * amount,
    g: rgb.g + (255 - rgb.g) * amount,
    b: rgb.b + (255 - rgb.b) * amount,
  });
}

// Perceptual luminance to pick a contrasting text color for buttons whose
// background is the accent (gold → dark text, deep blue → white text).
function contrastingFg(hex) {
  const rgb = hexToRgb(hex);
  if (!rgb) return "#121212";
  // sRGB relative luminance
  const chan = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };
  const L = 0.2126 * chan(rgb.r) + 0.7152 * chan(rgb.g) + 0.0722 * chan(rgb.b);
  return L > 0.55 ? "#121212" : "#ffffff";
}

export function applyOrgAccent(hex) {
  const accent = hex || DEFAULT_ACCENT;
  const root = document.documentElement;
  root.style.setProperty("--org-accent", accent);
  root.style.setProperty("--org-accent-hover", lightenHex(accent, 0.14));
  root.style.setProperty("--org-accent-soft", lightenHex(accent, 0.35));
  root.style.setProperty("--org-accent-fg", contrastingFg(accent));
}
